/**
 * Generates a unique string ID suitable for scoping ARIA relationships
 * (e.g., `aria-controls`, `aria-labelledby`, `aria-describedby`) within a
 * single component instance.
 *
 * Prefers `crypto.randomUUID()` when available (all modern browsers in secure
 * contexts). Falls back to a `Math.random()`-based string so the component
 * remains functional in non-secure contexts (`http://`) and SSR/test
 * environments where the Web Crypto API may be unavailable.
 *
 * @example
 * private readonly _uid = generateUid();
 * // renders as: id="${this._uid}-trigger" aria-controls="${this._uid}-panel"
 */
export function generateUid(): string {
  return globalThis.crypto?.randomUUID?.() ?? `uid-${Math.random().toString(36).slice(2)}`;
}
